import 'bootstrap'
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App'
import router from './router'
import store from './store/index'
import VueSimpleAlert from "vue-simple-alert";

import './assets/sass/app.scss'

Vue.use(VueRouter);
Vue.use(VueSimpleAlert);

new Vue({
  router,
  store,
  render: h => h(App),
    data: {
      prod_env: process.env.NODE_ENV !== 'development'
    }
}).$mount('#app');
